import { Device } from 'DeviceUtils';
import { Dimensions, StyleSheet } from 'react-native';

const isLong = Dimensions.get('window').height > 800;

const CanalPlus = StyleSheet.create({
    containerStyle: {
        justifyContent: 'space-between',
        paddingBottom: Device.isPhone ? (isLong ? '7.1%' : 0) : '7.1%'
    },
    buttonStyle: {
        width: Device.isTabletOrWeb ? 234 : '73.5%'
    }
});

export default {
    CanalPlus
};
